
import { types, actions } from './requests'
export const DELETEARTICLEVARIANT_TYPES = {
    ...types('DELETEARTICLEVARIANT'),
}
export const DELETEARTICLEVARIANT_ACTIONS = {
    ...actions('DELETEARTICLEVARIANT'),
}